import React from 'react'
import {AppStorage} from './storage'
import {View, Text, ScrollView, StyleSheet, TextInput, TouchableOpacity, Platform, Dimensions} from 'react-native'
import {isPortrait} from '../orientation'
import {RequestQuoteLineItem} from './request-quote-line-item'
import {RFQForm} from './request-quote-form'

type Props = {
  partner: string,
  /** Close the entire quote request page. */
  onClose: Function,
  /** Delete a SKU from the RFQ cart. */
  onDeleteCartItem: Function,
  /** Called when cookies are not enabled and a SKU is to be deleted from the RFQ cart */
  tpOnDeleteCartItem: Function,
  /** Called when the quantity changed for a line item */
  onQuantityChange: Function,
  /** Called when cookies are not enabled and a quantity is changed for a line item */
  tpOnQuantityChange: Function,
  /** Passes extra attributes for customizability for partners */
  extraAttributes: any,
}

export const RequestQuoteCart = ({partner, onClose, onDeleteCartItem, tpOnDeleteCartItem, onQuantityChange, tpOnQuantityChange, extraAttributes}: Props) => {
  const [cart, setCart] = React.useState([])
  const [formOpen, setFormOpen] = React.useState(false)

  React.useEffect(() => {
    if (navigator.cookieEnabled) {
      retrieveCart()
    } else {
      tpRetrieveCart()
    }
  }, [])

  const tpRetrieveCart = async () => {
    const message = { method: 'Retrieve Cart', payload: null }
    window.parent.postMessage(message, `${document.referrer}`)
    const handler = async (event:any) => {
      if (`${event.origin}/` === `${document.referrer}` && event.data.method === 'Retrieve Cart') {
        const dataCart = event.data.payload
        setCart(dataCart)
        window.removeEventListener('message', handler)
      }
    }
    window.addEventListener('message', handler)
    return
  }

  const retrieveCart = async () => {
    console.log("retrieveCart")
    const cart = JSON.parse(await AppStorage.getItem("@rfqCart"))
    console.log(cart)
    setCart(cart)
  }

  const _onDeleteCartItem =  async (sku) => {
    if (navigator.cookieEnabled) {
      await onDeleteCartItem(sku)
      await retrieveCart()
    } else {
      await tpOnDeleteCartItem(sku)
      await tpRetrieveCart()
    }
  }

  const _onQuantityChange = async (sku, value) => {
    if (navigator.cookieEnabled) {
      await onQuantityChange(sku, value)
      await retrieveCart()
    } else {
      await tpOnQuantityChange(sku, value)
      await tpRetrieveCart()
    }
  }

  const onOpenForm = () => {
    setFormOpen(true)
  }

  const onCloseForm = () => {
    setFormOpen(false)
  }

  return (
    <View
      style={styles.container}
    >
    {
      formOpen === true &&
      <RFQForm partner={partner} cart={cart} onBack={onCloseForm} onCloseAfterSubmit={onClose} extraAttributes={extraAttributes} />
    }
    {
      formOpen === false &&
      <>
        <ScrollView
          style={styles.scrollView}
        >
          {
            cart?.length > 0 ?
            cart.map((item, key) =>
              <RequestQuoteLineItem
                key={key}
                sku={item.sku}
                quantity={item.quantity}
                title={item.description}
                fisher={partner == 'fisher' || partner == 'fishered' || partner == 'fisheredu'}
                onDeleteCartItem={_onDeleteCartItem}
                onQuantityChange={_onQuantityChange}
              />
            )
            : <Text style={{fontSize: 18}}>There are no items in the quote cart.</Text>
          }
        </ScrollView>
        <Text style={styles.addMoreText}>Hit close to add more items to the quote.</Text>
        <View
          style={styles.btnContainer}
        >

          <TouchableOpacity
            style={styles.addMoreBtn}
            onPress={onClose}
          >
            <Text style={styles.close}>Close</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.continueBtn}
            onPress={onOpenForm}
          >
            <Text style={styles.continueText}>Continue</Text>
          </TouchableOpacity>
        </View>
      </>
    }


    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: Platform.OS === 'web' ? '100vw' : '100%',
    height: Platform.OS === 'web' ? '100vh' : '100%',
    minWidth: 200,
    minHeight: Dimensions.get('window').width > Dimensions.get('window').height ? 0 : 500,
    backgroundColor: '#F3F3F3',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  scrollView: {
    margin: 'auto',
    marginTop: 80,
    flex: 1,
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    width: '100%',
    marginBottom: 60
  },
  addMoreBtn: {
    margin: 20,
    backgroundColor: '#111',
    borderRadius: 5,
    padding: 10,
    maxWidth: 150,
    textAlign: 'center',
    width: '100%',
  },
  close: {
    color: 'white',
    textAlign: 'center',

  },
  continueBtn: {
    margin: 20,
    // marginBottom: 60,
    backgroundColor: '#111',
    borderRadius: 5,
    padding: 10,
    maxWidth: 150,
    width: '100%',
    textAlign: 'center',
  },
  continueText: {
    color: 'white',
    textAlign: 'center',
  },
})